/* eslint-disable angular/controller-name */
/* eslint-disable angular/controller-as */

(function iife() {
	"use strict";

	angular.module("dx.webapp.forgotPassword").
		controller("ForgotPasswordChangeRouteController", ForgotPasswordChangeRouteController);

	function ForgotPasswordChangeRouteController(
		$scope,
		$routeParams,
		$http,
		$location,
		$window,

		passwordValidationService,
		PasswordValidationErrorEnum,
		dxDialog,
		DX_URLS,
		dxLocalize,
		faults,
		dxIsNaN
	) {
		$scope.tokenValid = false;
		$scope.validatedErrorMessage = "";
		$scope.errorMessage = null;
		$scope.submitError = "";
		$scope.isSetPassword = $window.location.href.indexOf("set-password") > -1;

		function validateToken() {
			$http.get("/changepasswordtoken/validate/" + parseInt($routeParams.id, 10) + "/" + $routeParams.token).then(onSuccess, onError);

			function onSuccess(response) {
				var responseFaults = response.data.faults;

				if (!responseFaults) {
					$scope.tokenValid = true;
				} else if (responseFaults.indexOf(faults.TOKEN_EXPIRED) >= 0) {
					$scope.validatedErrorMessage = "ForgotPassword.Fail.ExpiredToken";
				} else if (responseFaults.indexOf(faults.TOKEN_ALREADY_USED) >= 0) {
					$scope.validatedErrorMessage = "ForgotPassword.Fail.LinkUsed";
				} else {
					$scope.validatedErrorMessage = "ForgotPassword.Fail.InvalidToken";
				}
			}

			function onError() {
				$scope.validatedErrorMessage = "ForgotPassword.Fail.InvalidToken";
			}
		}

		validateToken();

		$scope.validatePassword = function validatePassword() {
			$scope.passwordsMatch = $scope.newPassword === $scope.newPasswordConfirm;
			$scope.passwordValidationError = passwordValidationService.validate($scope.newPassword);

			setErrorMessage();
		};

		$scope.shouldShowErrorNewPassword = function shouldShowErrorNewPassword() {
			$scope.validatePassword();
			return $scope.passwordValidationError !== PasswordValidationErrorEnum.NONE && ($scope.form.newPassword.$touched || $scope.form.$submitted);
		};

		$scope.shouldShowErrorConfirmPassword = function shouldShowErrorConfirmPassword() {
			var errorMessageAndConfirmError = $scope.passwordValidationError === PasswordValidationErrorEnum.NONE;
			return errorMessageAndConfirmError && !$scope.passwordsMatch && !$scope.shouldShowErrorNewPassword() && ($scope.form.newPasswordConfirm.$touched || $scope.form.$submitted);
		};

		$scope.shouldShowSubmitError = function shouldShowSubmitError() {
			if ($scope.newPassword === "") {
				$scope.submitError = "";
			}

			return $scope.submitError !== "";
		};

		$scope.submit = function submit() {
			$scope.validatePassword();
			$scope.submitError = "";

			if ($scope.errorMessage) {
				return;
			}

			var postData = {
				id: parseInt($routeParams.id, 10),
				token: $routeParams.token,
				password: $scope.newPassword,
			};

			if (dxIsNaN(postData.id) || postData.token.length !== 32) {
				showErrorDialog(dxLocalize.get("ForgotPassword.Fail.InvalidToken"));
				return;
			}

			$http.post("/changepasswordtoken/use/", postData).then(onSuccess, onError);

			function onSuccess(response) {
				var responseFaults = response.data.faults;

				if (!responseFaults) {
					if ($scope.isSetPassword) {
						$location.path(DX_URLS.get("setPasswordPasswordChanged"));
					} else {
						$location.path(DX_URLS.get("forgotPasswordPasswordChanged"));
					}
				} else if (responseFaults.indexOf(faults.TOKEN_EXPIRED) >= 0) {
					showErrorDialog(dxLocalize.get("ForgotPassword.Fail.ExpiredToken"));
				} else if (responseFaults.indexOf(faults.TOKEN_ALREADY_USED) >= 0) {
					showErrorDialog(dxLocalize.get("ForgotPassword.Fail.LinkUsed"));
				} else if (responseFaults.indexOf(faults.PASSWORD_HAS_WHITESPACE) >= 0) {
					$scope.submitError = dxLocalize.get("PasswordWhitespace");
				} else if (responseFaults.indexOf(faults.PASSWORD_COMMON) >= 0) {
					$scope.submitError = dxLocalize.get("PasswordCommon");
				} else {
					showErrorDialog(dxLocalize.get("ForgotPassword.Fail.InvalidToken"));
				}
			}

			function onError() {
				showErrorDialog(dxLocalize.get("ForgotPassword.Fail.InvalidToken"));
			}
		};

		function setErrorMessage() {
			var errorKey = null;

			switch ($scope.passwordValidationError) {
				case PasswordValidationErrorEnum.TOO_SHORT:
					errorKey = "PasswordTooShort";
					break;
				case PasswordValidationErrorEnum.TOO_LONG:
					errorKey = "PasswordTooLong";
					break;
				case PasswordValidationErrorEnum.CONTAINS_WHITESPACE:
					errorKey = "PasswordWhitespace";
					break;
				case PasswordValidationErrorEnum.NONE:
					if (!$scope.passwordsMatch) {
						errorKey = "PasswordsAreNotAMatch";
					}

				// no default
			}

			$scope.errorMessage = errorKey === null ? null : dxLocalize.get(errorKey);
		}

		function showErrorDialog(title) {
			function redirectToForgotPassword() {
				dxDialog.closeMostRecent();
				$location.path(DX_URLS.get("forgotPassword"));
			}

			dxDialog.alert({
				title: title,
				body: dxLocalize.get("ForgotPassword.Fail.SendNewLink"),
				acceptText: dxLocalize.get("ForgotPassword.Fail.SendNewLinkButton"),
				acceptCallback: redirectToForgotPassword,
			});
		}
	}
}());
